export const ASK_GUEST_EVENT = "atfq:ask-guest";

export const askGuest = (g) => {
  const go = () => {
    window.dispatchEvent(new CustomEvent(ASK_GUEST_EVENT, { detail: g }));
    document.getElementById("atfq-ask")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  if (window.location.pathname !== "/") {
    sessionStorage.setItem("atfq_pending_guest", JSON.stringify(g));
    window.location.href = "/#atfq-ask";
    return;
  }
  go();
};

export const pendingGuest = () => {
  const raw = sessionStorage.getItem("atfq_pending_guest");
  if (!raw) return null;
  sessionStorage.removeItem("atfq_pending_guest");
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};
